import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    modules: {
      app
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js